import React from "react";

import ArticleCard from "components/articleCard/articleCard";

import { BreakfastShort } from "../../types";
import { mapBreakfastToArticleFormat } from "./utils";
import { AuthorsLinkList } from "components/authorsLinkList/authorsLinkList";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";

type PreviousCardProps = {
  event: BreakfastShort;
};
const PreviousCard = ({ event }: PreviousCardProps) => {
  const { track } = useMixpanelTracking();
  const data = mapBreakfastToArticleFormat(event);

  const handleTrackingEventClicked = async (data: { [key: string]: any }) => {
    await track("Breakfast previous card click", {
      ...data,
    });
  };

  return (
    <ArticleCard
      {...data}
      variant={"small"}
      cardClasses={"min-h-[189px]"}
      withImage={false}
      withExcerpt={false}
      onTrackingEventClicked={handleTrackingEventClicked}
      authorsLabel={
        <span className={"text-[14px] leading-[120%] text-mono-30"}>
          With{" "}
          <AuthorsLinkList
            authors={data.authors}
            plainText={true}
            secondaryTextClassName={"text-inherit"}
          />
        </span>
      }
    />
  );
};

export default PreviousCard;
